import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  Modal,
  Row,
  Select,
  message,
} from "antd";
import { find, get, map, pick } from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import service from "services";
import { filterOption } from "../../../../../core/helpers";
import { passwordEncrypt } from "../../../../../lib/admin";
import { SCALE_STATUS } from "../../_redux/constants";
import { checkIsNotNumber } from "app/ultils/constant";

const SmartScaleBBSModal = ({ config, onShowModal }) => {
  const { visible, isCreate, dataSource } = config;
  const [form] = Form.useForm();
  const listStation = useSelector((x) => x.app.listStationsV2Select);
  const [isFetching, setIsFetching] = useState(false);
  const [isDisabledCheckPort, setIsDisabledCheckPort] = useState(true);

  const title = isCreate ? "Tạo mới camera cân" : "Chỉnh sửa camera cân";
  const isEdit = !isCreate;

  const checkPort = async () => {
    try {
      const validateResult = await form.validateFields([
        "public_ip",
        "public_tcp_port",
        "public_http_port",
        "public_rtsp_port",
        "user",
      ]);
      if (!validateResult.outOfDate) {
        const tempData = pick(form.getFieldsValue(), [
          "public_ip",
          "public_tcp_port",
          "public_http_port",
          "public_rtsp_port",
          "user",
          "password",
        ]);
        if (!tempData.password && !tempData.confirm && isCreate) {
          message.warning({
            content: "Thông tin đã nhập thiếu mật khẩu",
          });
          return;
        }
        // show message and return
        // let data = pick(tempData, ["user"]);
        let data = {
          ip: "",
          port: "",
          username: "",
          password: "",
          login_type: "TCP",
        };
        data["password"] = isEdit ? dataSource.password : tempData.password;
        data["port"] = tempData.public_tcp_port;
        data["ip"] = tempData.public_ip;
        data["username"] = tempData.user;
        data["password"] = passwordEncrypt(data.password);
        const response = await service.DvrService.checkPort(data);
        let success = get(response, "success", false);
        let resMessage = get(response, "message");

        if (success) {
          message.success({
            content: "Kiểm tra port thành công.Thông tin port hợp lệ",
          });
        } else {
          message.error({
            content: `Kiểm tra port thất bại.${
              resMessage ||
              "TCP, username hoặc password bạn nhập chưa chính xác, vui lòng kiểm tra lại"
            }`,
          });
        }
        return response;
      }
    } catch (error) {}
  };

  const onSubmit = async (values) => {
    setIsFetching(true);
    const public_default = "none";
    const local_default = null;

    let data = {
      ...config.dataSource,
      _id: config.dataSource.id,
      scale_camera: {
        ...config.dataSource.camera_info,
        camera_offset: values.camera_offset,
      },
      status: values.status,
      bbs_camera_info: {
        ...values,
        local_ip: values.local_ip?.trim() || local_default,
        local_tcp_port: values.local_tcp_port?.trim() || local_default,
        local_http_port: values.local_http_port?.trim() || local_default,
        local_rtsp_port: values.local_rtsp_port?.trim() || local_default,
        public_ip: values.public_ip?.trim() || public_default,
        public_tcp_port: values.public_tcp_port?.trim() || public_default,
        public_http_port: values.public_http_port?.trim() || public_default,
        public_rtsp_port: values.public_rtsp_port?.trim() || public_default,
      },
    };

    service.SmartScaleService.updateSmartScaleV2(data)
      .then((res) => {
        const isSuccess = get(res, "data.success");
        if (isSuccess) {
          message.success("Sửa camera cân thành công");
          onShowModal(false);
        } else {
          message.error("Có lỗi khi sửa camera cân");
        }
      })
      .catch(() => {
        message.error("Có lỗi khi sửa camera cân");
      })
      .finally(() => setIsFetching(false));
  };

  const footer = (
    <div className="d-flex justify-content-end align-items-center">
      {isCreate && (
        <Button
          disabled={isDisabledCheckPort}
          type="dashed"
          onClick={checkPort}
        >
          Check Port
        </Button>
      )}
      <Button loading={isFetching} type="primary" onClick={form.submit}>
        Lưu
      </Button>
    </div>
  );

  const onValuesChange = (_, values) => {
    const { public_rtsp_port, public_ip, public_tcp_port, public_http_port } =
      values;
    let disableCheckPort = true;
    if (public_ip || public_rtsp_port || public_http_port || public_tcp_port) {
      disableCheckPort = false;
    }
    setIsDisabledCheckPort(disableCheckPort);
  };

  useEffect(() => {
    if (isCreate === false && visible) {
      let bbs_camera_info = get(dataSource, "bbs_camera_info");
      form.setFieldsValue({
        id: dataSource.id,
        connect_type: bbs_camera_info?.connect_type,
        camera_name: bbs_camera_info?.camera_name,
        camera_sn: bbs_camera_info?.camera_sn,
        camera_mac: bbs_camera_info?.camera_mac,
        public_ip: bbs_camera_info?.public_ip,
        public_tcp_port: bbs_camera_info?.public_tcp_port,
        public_http_port: bbs_camera_info?.public_http_port,
        public_rtsp_port: bbs_camera_info?.public_rtsp_port,
        local_ip: bbs_camera_info?.local_ip,
        local_tcp_port: bbs_camera_info?.local_tcp_port,
        local_http_port: bbs_camera_info?.local_http_port,
        local_rtsp_port: bbs_camera_info?.local_rtsp_port,
        ip: bbs_camera_info?.ip,
        user: bbs_camera_info?.user,
        password: bbs_camera_info?.password,
        camera_offset: dataSource.camera_info?.camera_offset,
        station_id: find(listStation, (x) => x.value == dataSource.station_id),
        mac_controller: bbs_camera_info?.mac_controller,
        status: dataSource.status,
      });
    } else {
      form.setFieldsValue({
        connect_type: undefined,
        camera_name: "",
        camera_sn: "",
        camera_mac: "",
        public_ip: "",
        public_tcp_port: "",
        public_http_port: "",
        public_rtsp_port: "",
        local_ip: null,
        local_tcp_port: null,
        local_http_port: null,
        local_rtsp_port: null,
        ip: "",
        user: "",
        password: "",
        confirm: "",
        station_id: undefined,
        camera_offset: undefined,
        mac_controller: "",
      });
    }
  }, [isCreate, visible, form, dataSource, listStation]);

  return (
    <Modal
      open={visible}
      title={title}
      footer={footer}
      width={600}
      onCancel={() => onShowModal(false)}
    >
      <Form
        labelCol={{ span: 8 }}
        labelAlign="left"
        form={form}
        onFinish={onSubmit}
        onValuesChange={onValuesChange}
      >
        <Form.Item
          required
          label="Kho"
          labelAlign="left"
          name="station_id"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn kho",
            },
          ]}
        >
          <Select
            disabled={true}
            filterOption={(inputValue, option) =>
              filterOption(inputValue, option.label)
            }
            placeholder="Chọn kho"
            labelInValue
            showSearch
            options={listStation}
          />
        </Form.Item>

        <Form.Item
          required
          label="Tên camera"
          labelAlign="left"
          name="camera_name"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập tên camera",
            },
          ]}
        >
          <Input placeholder="Nhập tên camera" />
        </Form.Item>

        <Form.Item
          required
          label="SN"
          labelAlign="left"
          name="camera_sn"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập SN",
            },
          ]}
        >
          <Input autoFocus placeholder="Nhập SN" />
        </Form.Item>

        <Form.Item
          required
          label="MAC Camera"
          labelAlign="left"
          name="camera_mac"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập MAC Camera",
            },
          ]}
        >
          <Input placeholder="Nhập MAC Camera" />
        </Form.Item>

        <Form.Item
          required
          label="MAC Controller"
          labelAlign="left"
          name="mac_controller"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập MAC Controller",
            },
          ]}
        >
          <Input placeholder="Nhập MAC Controller" />
        </Form.Item>

        <Form.Item
          required
          label="Loại kết nối"
          labelAlign="left"
          name="connect_type"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn loại kết nối",
            },
          ]}
        >
          <Select placeholder="Chọn loại kết nối">
            <Select.Option value={1}>Public</Select.Option>
            <Select.Option value={0}>Local</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Trạng thái"
          name="status"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn trạng thái cân",
            },
          ]}
        >
          <Select
            size="default"
            placeholder="Chọn trạng thái"
            style={{ width: "100%" }}
          >
            {map(SCALE_STATUS, (scaleStatus) => (
              <Select.Option key={scaleStatus.value} value={scaleStatus.value}>
                {scaleStatus.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="camera_offset"
          label="Camera offset"
          rules={[
            {
              validator: checkIsNotNumber,
              message: "Vui lòng nhập số",
            },
          ]}
        >
          <Input className="w-100" placeholder="Nhập camera offset" />
        </Form.Item>

        <Divider className="text-primary" orientation="left">
          Public
        </Divider>

        <Form.Item dependencies={["local_ip"]} noStyle={true}>
          {({ getFieldValue }) => {
            let isRequired = !getFieldValue("local_ip");
            return (
              <Form.Item
                label="IP/Domain"
                labelAlign="left"
                name="public_ip"
                required={isRequired}
                rules={[
                  {
                    required: isRequired,
                    message: "Vui lòng nhập địa chỉ ip hoặc tên miền",
                  },
                ]}
              >
                <Input placeholder="Nhập địa chỉ ip hoặc domain" />
              </Form.Item>
            );
          }}
        </Form.Item>

        <Row gutter={[8]}>
          <Col span={8}>
            <Form.Item dependencies={["local_tcp_port"]} noStyle={true}>
              {({ getFieldValue }) => {
                let isRequired = !getFieldValue("local_tcp_port");
                return (
                  <Form.Item
                    label="TCP"
                    labelAlign="left"
                    labelCol={{ span: 8 }}
                    name="public_tcp_port"
                    required={isRequired}
                    rules={[
                      {
                        required: isRequired,
                        message: "Vui lòng nhập cổng",
                      },
                    ]}
                  >
                    <Input placeholder="Port TCP" />
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item dependencies={["local_http_port"]} noStyle={true}>
              {({ getFieldValue }) => {
                let isRequired = !getFieldValue("local_http_port");
                return (
                  <Form.Item
                    label="HTTP"
                    labelAlign="left"
                    labelCol={{ span: 8 }}
                    name="public_http_port"
                    required={isRequired}
                    rules={[
                      {
                        required: isRequired,
                        message: "Vui lòng nhập cổng",
                      },
                    ]}
                  >
                    <Input placeholder="Port HTTP" />
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item dependencies={["local_tcp_port"]} noStyle={true}>
              {({ getFieldValue }) => {
                let isRequired = !getFieldValue("local_rtsp_port");
                return (
                  <Form.Item
                    label="RTSP"
                    labelAlign="left"
                    labelCol={{ span: 8 }}
                    name="public_rtsp_port"
                    required={isRequired}
                    rules={[
                      {
                        required: isRequired,
                        message: "Vui lòng nhập cổng",
                      },
                    ]}
                  >
                    <Input placeholder="Port RTSP" />
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
        </Row>
        <Divider className="text-primary" orientation="left">
          Local
        </Divider>
        <Form.Item label="IP/Domain" labelAlign="left" name="local_ip">
          <Input placeholder="Nhập địa chỉ ip hoặc domain" />
        </Form.Item>
        <Row gutter={[8]}>
          <Col span={8}>
            <Form.Item
              label="TCP"
              labelAlign="left"
              labelCol={{ span: 8 }}
              name="local_tcp_port"
            >
              <Input placeholder="Port TCP" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="HTTP"
              labelAlign="left"
              labelCol={{ span: 8 }}
              name="local_http_port"
            >
              <Input placeholder="Port HTTP" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="RTSP"
              labelAlign="left"
              labelCol={{ span: 8 }}
              name="local_rtsp_port"
            >
              <Input placeholder="Port RTSP" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          required
          initialValue="admin"
          label="Tài khoản"
          labelAlign="left"
          name="user"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập tên tài khoản",
            },
          ]}
        >
          <Input
            autoComplete="off"
            placeholder="Nhập tên tài khoản đăng nhập"
          />
        </Form.Item>

        <Form.Item
          label="Mật khẩu"
          labelAlign="left"
          required={!isEdit}
          name="password"
          rules={[
            {
              required: !isEdit,
              message: "Vui lòng nhập mật khẩu",
            },
          ]}
        >
          <Input.Password placeholder="Nhập mật khẩu đăng nhập" />
        </Form.Item>

        <Form.Item
          hasFeedback
          dependencies={["password"]}
          label="Xác nhận"
          required={!isEdit}
          labelAlign="left"
          name="confirm"
          rules={[
            ({ getFieldValue }) => ({
              validator(rule, value) {
                if (getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject("Mật khẩu không trùng khớp");
              },
            }),
          ]}
        >
          <Input.Password placeholder="Xác nhận mật khẩu" />
        </Form.Item>

        {isCreate === false && (
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default SmartScaleBBSModal;
